import { Component, input, InputSignal } from "@angular/core";
import { FloatingButtonsModel } from "./model/floating-buttons-model";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "portal-floating-buttons",
  templateUrl: "./floating-buttons.component.html",
  standalone: true,
  styleUrls: ["./floating-buttons.component.scss"],
  imports: [TranslatePipe],
})
export class FloatingButtonsComponent {
  floatingButtonsModel: InputSignal<FloatingButtonsModel> = input.required();

  scrollTop(): void {
    window.scroll(0, 0);
  }
}
